import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { Toaster } from 'react-hot-toast';

import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import ClinicList from './pages/ClinicList';
import ClinicDetail from './pages/ClinicDetail';
import ProviderList from './pages/ProviderList';
import PatientList from './pages/PatientList';
import PatientHistory from './pages/PatientHistory';
import Usage from './pages/Usage';
import ProtocolCost from './pages/ProtocolCost';
import DemoRequests from './pages/DemoRequests';
import WebsiteAnalytics from './pages/WebsiteAnalytics';
import Credits from './pages/Credits';
import AuditLog from './pages/AuditLog';
import Settings from './pages/Settings';
import ForcePasswordChange from './pages/ForcePasswordChange';
import CreditHistory from './pages/CreditHistory';

function PrivateRoute({ children }) {
  const { isAuthenticated, loading, mustChangePassword } = useAuth();
  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  // A password someone else set has to be replaced before anything else will load.
  if (mustChangePassword) return <ForcePasswordChange />;
  return children;
}

function AppContent() {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return null;

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <Toaster position="top-right" />
      <Routes>
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
        />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="customers" element={<Customers />} />
          <Route path="clinics" element={<ClinicList />} />
          <Route path="clinics/:clinicId" element={<ClinicDetail />} />
          <Route path="providers" element={<ProviderList />} />
          <Route path="patients" element={<PatientList />} />
          <Route path="patients/:patientId/history" element={<PatientHistory />} />
          <Route path="usage" element={<Usage />} />
          <Route path="protocol-cost" element={<ProtocolCost />} />
          <Route path="demo-requests" element={<DemoRequests />} />
          <Route path="website-analytics" element={<WebsiteAnalytics />} />
          <Route path="credits" element={<Credits />} />
          <Route path="credits/history" element={<CreditHistory />} />
          <Route path="audit" element={<AuditLog />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </Box>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
